import { PartnerOrganization } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { JsonField } from "@shared/helpers/custom-fields";
import { Fields, Relations } from "remult";
import { PartnerOrganizationAddressEntityConfig } from "./config";
import { PartnerOrganizationAddressFilters } from "./filters";
import { PartnerOrganizationAddressMethods } from "./methods";

@HyperEntity(
  "partner-organization-address",
  PartnerOrganizationAddressEntityConfig,
)
export class PartnerOrganizationAddress extends extender(
  PartnerOrganizationAddressFilters,
  PartnerOrganizationAddressMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "partner_organization_id" })
  partnerOrganizationId = "";

  @Relations.toOne<PartnerOrganizationAddress, PartnerOrganization>(
    () => PartnerOrganization,
    "partnerOrganizationId",
  )
  partnerOrganization?: PartnerOrganization;

  @Fields.string({ allowNull: true, caption: "תווית" })
  label = "";

  @Fields.string({ caption: "כתובת" })
  address = "";

  @JsonField<PartnerOrganizationAddress, { lat: number; lng: number }>({
    allowedKeys: ["lat", "lng"],
    allowNull: true,
  })
  coordinates?: { lat: number; lng: number } | null;

  @Fields.integer({ dbName: "sort_order" })
  sortOrder = 0;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
